import {styled} from '@esgi/ui/theme';
import {RadioGroup as RadioGroupRadix} from '@radix-ui/react-radio-group';

export const RadioGroup = styled(RadioGroupRadix, {
	display: 'inline-grid',
	boxSizing: 'border-box',
});
